// extracted by mini-css-extract-plugin
export default {"color-swatch-button":"ColorSwatches___colorSwatchButton-module__color-swatch-button___IoH5t"};